<template>
  <el-container style="width: 100%">
    <el-header>
      <el-button round @click="createClick">{{generateCustomizeString('add')}}</el-button>
      <el-button round @click="freshClick">{{generateCustomizeString('refresh')}}</el-button>
    </el-header>
    <el-main v-loading.body="categoryListLoading">
      <el-table
        :data="data"
        row-key="id"
        border
        :tree-props="{children: 'children'}"
        :header-cell-style="{'text-align':'center', 'font-size': '16px', 'color': '#000', 'background-color': '#f5f5f6'}"
        style="font-size: 16px; color: #000; width: 98%; margin: 20px auto 60px;"
        >
        <el-table-column
          prop="categoriesName"
          :label="generateCustomizeString('categoryName')"
          width="200"
        >
        </el-table-column>
        <el-table-column
          prop="categoriesIcon"
          :label="generateCustomizeString('categoryLogo')"
          width="120"
        >
          <template slot-scope="scope">
            <el-image v-if="scope.row.categoriesIconImg" :src="'https://img.nzmai.com.cn/' + scope.row.categoriesIconImg + '?imageView2/0/w/200/h/200/q/75|imageslim'" style="margin-left: 35px; width: 26px;"></el-image>
            <i v-else v-bind:class="'iconfont ' + scope.row.categoriesIcon" class="category_font" style="margin-left: 35px;"></i>
          </template>
        </el-table-column>
        <el-table-column
          prop="categoriesDetail"
          :label="generateCustomizeString('categoryDescription')"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="categoriesSortWeight"
          :label="generateCustomizeString('rankingWeight')"
          width="120">
        </el-table-column>
        <el-table-column
          prop="categoriesIsNav"
          :label="generateCustomizeString('menu')"
          width="120">
        </el-table-column>
        <el-table-column
          prop="isPcMenu"
          :label="generateCustomizeString('pcMenu')"
          width="120">
        </el-table-column>
        <el-table-column
          prop="isPcModel"
          :label="generateCustomizeString('pcModel')"
          width="135">
        </el-table-column>
        <el-table-column
          prop="isAgent"
          :label="generateCustomizeString('isAgentVisible')"
          width="120">
        </el-table-column>
        <el-table-column
          prop="operation"
          :label="generateCustomizeString('operate')"
          width="200"
          >
          <template slot-scope="scope">
            <el-button
              @click="editClick(scope.row)"
              type="primary"
              size="small"
              style="margin-left: 30px;"
            >{{generateCustomizeString('edit')}}</el-button>
            <el-button
              @click="deleteClick(scope.row)"
              type="danger"
              size="small"
            >{{generateCustomizeString('delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog :title="generateCustomizeString('confirmDelete')" :visible.sync="dialogVisible" width="30%" :append-to-body="true">
        <!-- <span>{{ generateCustomizeString('confirmDelete') }}</span> -->
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">{{ generateCustomizeString('cancel')}}</el-button>
          <el-button type="primary" @click="deleteCategory">{{ generateCustomizeString('confirm') }}</el-button>
        </span>
      </el-dialog>
    </el-main>

    <el-footer style="position: fixed; bottom: 0; width: 100%; z-index:9999; padding-top:15px;">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="15"
        layout="total, prev, pager, next"
        :total="currentTotal"
      ></el-pagination>
    </el-footer>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

export default {
  name: 'Categories',
  data() {
    return {
      categoryListLoading: false,
      dialogVisible: false,
      selectCategoryId: 0,
      currentPage: 1,
      currentTotal: 0,
      pageSize: 15,
      columns: [
        {
          title: this.generateCustomizeString('categoryName'),
          key: 'categoriesName',
          width: '200'
        },
        {
          title: this.generateCustomizeString('categoryLogo'),
          type: 'icon',
          key: 'categoriesIcon',
          width: '120'
        },
        {
          title: this.generateCustomizeString('categoryDescription'),
          key: 'categoriesDetail',
          width: '350'
        },
        {
          title: this.generateCustomizeString('rankingWeight'),
          key: 'categoriesSortWeight',
          width: '120'
        },
        {
          title: this.generateCustomizeString('menu'),
          key: 'categoriesIsNav',
          width: '120'
        },
        // {
        //   title: '导航栏',
        //   key: 'categoriesIsIndex',
        //   width: '120'
        // },
        {
          title: this.generateCustomizeString('operate'),
          type: 'action',
          actions: [
            {
              type: 'primary',
              text: this.generateCustomizeString('edit')
            },
            {
              type: 'danger',
              text: this.generateCustomizeString('delete')
            }
          ],
          width: '150'
        }
      ],
      data: []
    }
  },

  methods: {
    generateCustomizeString,
    editClick(row) {
      this.$router.push({
        name: 'EditCategories',
        params: { categoryId: row.id }
      })
    },
    deleteClick(row) {
      this.selectCategoryId = row.id
      this.dialogVisible = true
    },
    handleCurrentChange(val) {
      this.fetchData(val)
    },
    rowClick(data, event, index, actionText) {
      if (actionText === '编辑') {
        this.$router.push({
          name: 'EditCategories',
          params: { categoryId: data.id }
        })
      }

      if (actionText === '删除') {
        // console.log(data.id)
        this.selectCategoryId = data.id
        this.dialogVisible = true
      }
    },
    selectionClick(arr) {
      // console.log('选中数据id数组:' + arr)
    },
    sortClick(key, type) {
      // console.log('排序字段:' + key)
      // console.log('排序规则:' + type)
    },
    freshClick() {
      this.fetchData(this.currentPage)
    },
    createClick() {
      this.$router.push({ name: 'CreateCategories' })
    },
    deleteCategory() {
      if (this.selectCategoryId === 0) return
      request({
        url: 'category/' + this.selectCategoryId,
        method: 'delete'
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('deletedSuccessfully'),
              type: 'success'
            })
          } else {
            if (res.status === 60017) {
              this.$message.error(this.generateCustomizeString('categoryDeletedError'))
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.fetchData(this.currentPage)
          this.dialogVisible = false
        })
    },
    fetchData(page) {
      if (this.categoryListLoading) return
      this.categoryListLoading = true

      request({
        url: '/categories',
        method: 'get',
        params: {
          page: page,
          page_size: this.pageSize
        }
      })
        .then(response => {
          const data = response.data
          const meta = response.meta

          for (let i = 0; i < response.data.length; i++) {
            var obj = {}
            obj.id = response.data[i].id
            obj.categoriesName = response.data[i].name
            obj.categoriesIcon = response.data[i].icon_name
            obj.categoriesDetail = response.data[i].desc
            obj.categoriesSortWeight = response.data[i].sort_by
            obj.categoriesIconImg = response.data[i].icon_img_key
            obj.categoriesIsNav =
              response.data[i].is_nav === 1 ? this.generateCustomizeString('show') : this.generateCustomizeString('hide')
            obj.categoriesIsIndex =
              response.data[i].is_index === 1 ? this.generateCustomizeString('show') : this.generateCustomizeString('hide')
            obj.isPcMenu = response.data[i].is_pc_menu === 1 ? this.generateCustomizeString('show') : this.generateCustomizeString('hide')
            obj.isPcModel = response.data[i].is_pc_model === 1 ? this.generateCustomizeString('show') : this.generateCustomizeString('hide')
            obj.isAgent = response.data[i].is_agent_visible === 1 ? this.generateCustomizeString('show') : this.generateCustomizeString('hide')
            const sub = response.data[i].sub_categories
            for (let j = 0; j < response.data[i].sub_categories.length; j++) {
              var sobj = {}
              sobj.id = response.data[i].sub_categories[j].id
              sobj.categoriesName = response.data[i].sub_categories[j].name
              sobj.categoriesDetail = response.data[i].sub_categories[j].desc
              sobj.categoriesSortWeight =
                response.data[i].sub_categories[j].sort_by
              sobj.categoriesIcon = response.data[i].sub_categories[j].icon_name
              sobj.categoriesIconImg = response.data[i].sub_categories[j].icon_img_key
              // sobj.categoriesIsNav =
              //   response.data[i].sub_categories[j].is_nav === 1
              //     ? '显示'
              //     : '隐藏'
              // sobj.categoriesIsIndex =
              //   response.data[i].sub_categories[j].is_index === 1
              //     ? '显示'
              //     : '隐藏'
              sub[j] = sobj
            }
            obj.children = sub
            data[i] = obj
          }

          this.data = data
          this.currentPage = meta.current_page
          this.currentTotal = meta.total
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.categoryListLoading = false
        })
    }
  },
  created: function() {
    this.fetchData(1)
  },
  computed: {
    viewActived() {
      return this.$store.state.tagsView.changedViewEvent
    }
  },
  watch: {
    viewActived: function(newValue) {
      this.freshClick()
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.meta && to.meta.badge) {
      to.meta.badge = null
    }
    next()
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-header,
.el-footer {
  background-color: #efefef;
  // color: #333;
  text-align: left;
  line-height: 60px;
}
.text-center {
  padding-left: 20px;
}
</style>
<style type="text/css">
.el-table .cell {
  line-height: 26px;
}
</style>
